import React from "react";
import { addSpreadsheetToGapiClient } from "fe-web-components/diagnostics/debugsheetExporter";
import { isProduction } from "fe-common/utils/envGetter";
import * as Sentry from "@sentry/browser";
import { useCreateHistory } from "fe-common/routes/createHistory";
import { Redirect, Route, Router, Switch } from "react-router";
import { PatientForgotPassword } from "./login/PatientForgotPassword";
import { PatientSignUp } from "./login/PatientSignUp";
import { PatientLogin } from "./login/PatientLogin";
import { DemoRouter } from "./demo/demoRouter";
import { Logout } from "user-management/src/components/logout";
import { PatientVerify } from "./login/PatientVerify";
import { PatientInnerApp } from "./layout/patinetInnerApp";
//x
if (!isProduction()) {
  addSpreadsheetToGapiClient();
}

const tempNovartisRedirectedCases: string[] = [
  "93873ac3-f8c2-4a9f-897d-ba8ffa23ebf6",
];

function App() {
  // Initilize sentry only in app mode, so the widget won't send 3rd party erros
  Sentry.init({
    dsn: "https://185e83bc311443e9a417c990520e2320@sentry.io/5183085",
  });
  // Support cordova memory history
  const history = useCreateHistory();

  console.log("USING MUI - V5");

  return (
    <Router history={history}>
      {
        // Temp Novartis patch -nRedirect to the clinic if the wrong case id is in the url
      }
      {tempNovartisRedirectedCases.some((caseId) =>
        window.location.search.includes(caseId),
      ) && (
        <Redirect to={`/clinic/a73bbac2-7ecb-45da-8a67-78212f236bd6/welcome`} />
      )}
      <Switch>
        <Route path="/login" exact component={PatientLogin} />
        <Route
          path="/logout"
          exact
          render={() => (
            <Logout>
              <Redirect to={"/"} />
            </Logout>
          )}
        />
        <Route path="/demosignup" component={DemoRouter} />
        <Route path="/verify" exact component={PatientVerify} />
        <Route
          path="/forgot_password"
          exact
          component={PatientForgotPassword}
        />
        <Route path="/signup" exact component={PatientSignUp} />
        {/* We need to put the default route without exact to allow inner router,
         and it should be at the end to enable other routes*/}
        <Route
          path="/"
          render={({ match }) => {
            if (
              match.isExact &&
              window.location?.hostname.includes("demo.kahun")
            ) {
              // handle demo landing pages
              return (
                <Redirect
                  to={{
                    pathname: "/demosignup",
                    state: { signupCohort: "ata2020" }, //<-- for the duration of this conference only
                  }}
                />
              );
            }

            // Render app, and clinic context on the lower level
            return <PatientInnerApp />;
          }}
        />
      </Switch>
    </Router>
  );
}

export default App;
